import { makeStyles } from '@material-ui/core';
import typography from 'theme/typography';
import { COLORS } from 'constants/index';

interface StyleProps {
  isMini?: boolean;
  isNested?: boolean;
  size: 'normal' | 'small' | 'mini';
}

const getCardHeight = ({ size }: StyleProps) => {
  switch (size) {
    case 'small':
      return '308px';
    case 'mini':
      return '260px';
    default:
      return '484px';
  }
};

const getCardContentHeight = ({ size }: StyleProps) => {
  switch (size) {
    case 'small':
      return '69%';
    case 'mini':
      return '64%';
    default:
      return '80%';
  }
};

const useStyles = makeStyles({
  root: {
    height: ({ isNested }: StyleProps) => (isNested ? '100%' : '100vh'),
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    zIndex: 10000,
    backgroundColor: COLORS.BLACK_3,
  },
  card: {
    width: '418px',
    // Note: bump height back when new price picker is added
    height: getCardHeight,
    boxShadow: ({ isNested }: StyleProps) => (isNested ? 'none' : ''),
  },
  cardContent: {
    padding: '48px 32px',
    height: getCardContentHeight,
  },
  footer: {
    paddingLeft: '18px',
    paddingRight: '18px',
    '& a': {
      ...typography.subtitle1,
    },
  },
});

export default useStyles;
